import React from 'react';
import { PopUpContentProps } from '../types';

export const PopUpContent = (_props: PopUpContentProps): JSX.Element => <></>;
